{
  "it": {
    "phase": {
      "attributes": {
        "end_date": "Data di fine",
        "internal_note": "Nota interna della fase",
        "name": "Nome",
        "start_date": "Data di inizio"
      },
      "labels": {
        "phase": "Nessuna fase | Una fase | {count} fasi"
      },
      "toasts": {
        "create": "Fase creata",
        "delete": "Fase eliminata",
        "update": "Fase aggiornata"
      },
      "validation": {
        "needName": "Il titolo è obbligatorio",
        "needNumber": "Deve essere un numero (ad es. 85)"
      }
    }
  }
}
